import { graphql } from "@/gql";

export const billingEntitiesQuery = graphql(`
  query BillingEntities($supplier_id: ID) {
    billingEntities(supplier_id: $supplier_id) {
      ...ContactRecordFields
      ...StripeCustomerFields
    }
  }
`);
